import { render, staticRenderFns } from "./AddCurrencyPayment.vue?vue&type=template&id=2f0c4e1a"
import script from "./AddCurrencyPayment.vue?vue&type=script&lang=js"
export * from "./AddCurrencyPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports